export default {
  path: "/SectionContent/ReportingCrashesWithTrains",
  name: "Reporting Motor Vehicle Crashes with Trains",
  htmlContent: "reporting_motor_vehicle_crashes_with_trains.html",
  headings: [],
};
